import { initializeApp } from "firebase/app";
import firebaseConfig from "@/services/firebaseConfig";

const app = initializeApp(firebaseConfig);

export default app;
